module.exports = __webpack_public_path__ + "img/MisionTB.6f67ce95.jpg";